import { UserFilters } from './components/UserFilters';
import { UserTable } from './components/UserTable';
import { BulkActionsBar } from './components/BulkActionsBar';

export default function UsersPage() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="font-display text-3xl font-bold">User Management</h2>
        <p className="text-sm text-on-surface-variant mt-1">
          Search, filter, suspend, and audit every user on the platform.
        </p>
      </div>
      <UserFilters />
      <UserTable />
      <BulkActionsBar />
    </div>
  );
}
